import dayjs from "dayjs";
import {PersonDocumentType} from "arteco-api-client-ts";

/** Cómo caduca un tipo de documento (#14381), en español. */
export const EXPIRATION_MODE_LABELS: Record<string, string> = {
	NONE: "No caduca",
	MANUAL: "La fecha la indica quien lo sube",
	AUTO: "Se calcula sola, a tantos meses del año y mes del documento",
};

/** Cada cuánto se exige un documento obligatorio (#14415), en español. */
export const REQUIRED_PERIOD_LABELS: Record<string, string> = {
	ONCE: "Una vez: basta con tener uno vigente",
	MONTHLY: "Cada mes: uno del último mes cerrado",
	YEARLY: "Cada año: uno del último año cerrado",
};

/** Lo corto, para las etiquetas de la lista y las cabeceras. */
export const REQUIRED_PERIOD_SHORT: Record<string, string> = {
	ONCE: "una vez",
	MONTHLY: "cada mes",
	YEARLY: "cada año",
};

/** Meses en palabras: «6 meses», «1 año», «10 años». */
export const monthsLabel = (months?: number): string => {
	if (!months) return "";
	if (months % 12 === 0) {
		const years = months / 12;
		return years === 1 ? "1 año" : years + " años";
	}
	return months === 1 ? "1 mes" : months + " meses";
};

export const isAutoExpiration = (type?: PersonDocumentType): boolean =>
	type?.expirationMode === "AUTO" && (type.expirationMonths || 0) > 0;

/** Año y mes con los que se puede contar: mes del 1 al 12 y un año con sentido (como en el servidor). */
export const hasYearMonth = (year?: number | string | null, month?: number | string | null): boolean => {
	const y = Number(year), m = Number(month);
	return year !== "" && year != null && month !== "" && month != null
		&& Number.isInteger(y) && Number.isInteger(m) && m >= 1 && m <= 12 && y >= 1900 && y <= 2100;
};

/**
 * La caducidad que pondrá el servidor a un documento de ese tipo (DD/MM/AAAA), o "" si no se puede saber
 * (#14387): el día 1 de su año y mes más los meses del tipo. Sin año y mes, desde la subida (hoy, si es nuevo).
 */
export const autoExpirationFor = (type?: PersonDocumentType, year?: number | string | null, month?: number | string | null,
								  uploaded?: string): string => {
	if (!isAutoExpiration(type)) return "";
	const from = hasYearMonth(year, month)
		? dayjs(new Date(Number(year), Number(month) - 1, 1))
		: (uploaded ? dayjs(uploaded) : dayjs());
	return from.add(type!.expirationMonths!, "month").format("DD/MM/YYYY");
};

const MONTH_NAMES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre",
	"noviembre", "diciembre"];

/** «marzo de 2026». */
export const yearMonthLabel = (year?: number | string | null, month?: number | string | null): string =>
	hasYearMonth(year, month) ? MONTH_NAMES[Number(month) - 1] + " de " + Number(year) : "";
